import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Componente que maneja la ruta /baterias/:slug
 * Parsea el slug combinado (ej: toyota-4runner-2010) y redirige a la ruta antigua
 * para mantener compatibilidad con el código existente
 */
@Component({
  selector: 'allas-baterias-slug',
  template: `
    <div class="flex items-center justify-center min-h-screen">
      <div class="text-center">
        <div class="text-gray-400 mb-4">
          <svg
            class="mx-auto w-8 h-8 animate-spin"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
        <p class="text-gray-600">Cargando...</p>
      </div>
    </div>
  `,
})
export class BateriasSlug implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  ngOnInit() {
    this.route.params.subscribe((params) => {
      const slug = params['slug'];
      if (!slug) {
        this.router.navigate(['/baterias-carros-honduras']);
        return;
      }

      // Parsear el slug: formato esperado marca-modelo-año
      // El año es siempre un número de 4 dígitos al final
      const parts = slug.split('-');
      
      if (parts.length < 3) {
        // Si no tiene al menos 3 partes, redirigir a la página principal de baterías
        this.router.navigate(['/baterias-carros-honduras']);
        return;
      }

      // El último elemento debería ser el año (4 dígitos)
      const lastPart = parts[parts.length - 1];
      const yearMatch = lastPart.match(/^(\d{4})$/);
      
      if (!yearMatch) {
        // Si el último elemento no es un año válido, redirigir
        this.router.navigate(['/baterias-carros-honduras']);
        return;
      }

      const anio = yearMatch[1];
      // Todo lo anterior al año es marca-modelo (puede tener guiones internos)
      const marcaModelo = parts.slice(0, -1).join('-');
      
      // Intentar separar marca y modelo
      // Asumimos que la marca es la primera palabra y el resto es el modelo
      const marcaModeloParts = marcaModelo.split('-');
      const marca = marcaModeloParts[0];
      const modelo = marcaModeloParts.slice(1).join('-');

      // Redirigir a la ruta antigua para mantener compatibilidad
      this.router.navigate([
        '/repuestos',
        'bateria-para-carro-auto-o-camioneta',
        marca,
        modelo,
        anio,
      ], { replaceUrl: true });
    });
  }
}

